import { Query } from 'acast-reactor';

export default function createTransaction(name, verb, data) {
  const queryName = `${name.toLowerCase()}/${verb.toLowerCase()}`;

  let tx = null;

  try {
    tx = Query.run(queryName, data);
  } catch (e) {
    if (/unknown query/gi.test(e.message)) {
      tx = Query.run('Query/delegate', {
        query: queryName,
        args: [data],
      });
    }
  }

  if (!tx) return Promise.reject(`Query.run(${queryName}) failed. Is it a valid query name?`);

  return tx.asPromise();
}
